module.exports = __webpack_public_path__ + "be186d40f2f5d0b4dfce199d072ff57b.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../images/speakers/small/dan-abramov.jpg
// module id = 661
// module chunks = 0